import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getExistingCheckIn } from '../queries/submitCheckIns';

export function useGetCheckInBySession(
  userId: string | undefined,
  shadowId: string | undefined | null,
  dailySequence: number,
): UseQueryResult<
  {
    userCheckinId: string | null;
    shadowCheckinIds: string[] | null;
    hasUserCheckin: boolean;
    hasShadowCheckin: boolean;
  },
  Error
> {
  return useQuery({
    queryKey: ['checkInSequence', userId, shadowId, dailySequence],
    queryFn: async (): Promise<{
      userCheckinId: string | null;
      shadowCheckinIds: string[] | null;
      hasUserCheckin: boolean;
      hasShadowCheckin: boolean;
    }> => {
      const existingCheckins = await getExistingCheckIn(
        userId,
        shadowId,
        dailySequence,
      );
      return {
        userCheckinId: userId ? existingCheckins[userId]?.[0] ?? null : null,
        shadowCheckinIds: shadowId ? existingCheckins[shadowId] ?? null : null,
        hasUserCheckin: userId ? existingCheckins[userId]?.length > 0 : false,
        hasShadowCheckin: shadowId
          ? existingCheckins[shadowId]?.length > 0
          : false,
      };
    },
    refetchOnWindowFocus: true,
    enabled: !!userId,
  });
}
